import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import {
  login as loginAction,
  register as registerAction,
  logout as logoutAction,
  getCurrentUser,
  selectAuth,
  selectUser,
  selectIsAuthenticated,
  selectAuthLoading,
  selectAuthError,
  clearError,
} from '@store/slices/authSlice';

export const useAuth = () => {
  const dispatch = useDispatch();
  const auth = useSelector(selectAuth);
  const user = useSelector(selectUser);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const loading = useSelector(selectAuthLoading);
  const error = useSelector(selectAuthError);

  const login = useCallback(
    async (credentials) => {
      const result = await dispatch(loginAction(credentials));
      return result;
    },
    [dispatch]
  );

  const register = useCallback(
    async (userData) => {
      const result = await dispatch(registerAction(userData));
      return result;
    },
    [dispatch]
  );

  const logout = useCallback(async () => {
    await dispatch(logoutAction());
  }, [dispatch]);

  const refreshUser = useCallback(async () => {
    await dispatch(getCurrentUser());
  }, [dispatch]);

  const clearAuthError = useCallback(() => {
    dispatch(clearError());
  }, [dispatch]);

  return {
    auth,
    user,
    isAuthenticated,
    loading,
    error,
    login,
    register,
    logout,
    refreshUser,
    clearAuthError,
  };
};

export default useAuth;
